import styled from "styled-components"
import { Colors } from "styles/app-styles"

const YearValuesContainer = styled.div`
  display: grid;
  grid-template-columns: 84px repeat(1, 1fr);
  grid-column-gap: 0px;
  margin-top: 8px;
  height: 465px;
  width: 100%;
  border: 1px solid ${Colors.towerGrey};
  .label-column {
    margin-top: 28px;
    text-align: right;
    .month-label {
      color: ${Colors.blackPearl};
      height: 26px;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 6px;
      padding-right: 8px;
    }
  }
`;

const YearValueColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: hidden;
  border-left: 1px solid ${Colors.towerGrey};
  padding-left: 6px;
  .year-column {
    margin-top: 5px;
    margin-right: 4px;
    .month-input {
      flex: 0 0 100px;
      margin-bottom: 5px;
    }
    .year-header {
      font-size: 14px;
      font-weight: 500;
      color: ${Colors.blackPearl};
      margin-bottom: 2px;
      padding-left: 10px;
    }
  }
`;

const Input = styled.div`
  width: 161px;
  input[type='text']{
    height: 26px !important;
    width: 129px;
    border: 1px solid ${Colors.towerGrey} !important;
    font-size: 14px;
  }
  .caret-right {
    position: relative;
    cursor: pointer;
    top: 2px;
    margin-left: 9px;
    img {
      width: 18px;
    }
  }
  .caret-down {
    opacity: 0;
    position: relative;
    top: 6px;
    left: 2px;
    cursor: pointer;
    img {
      width: 12px;
    }
  }
  .caret-down:hover {
    opacity: 1;
  }
`;

export { YearValuesContainer, Input, YearValueColumnContainer };